import {NgModule} from '@angular/core'
import {Routes, RouterModule} from '@angular/router'
import {DashboardsComponent} from './dashboards/dashboards.component'
import {GraficoComponent} from './grafico/grafico.component'
// import { LoginComponent } from './login/login.component';
import {HomeComponent} from './home/home.component'
import {MainComponent} from './main/main.component'
import {FiltrosComponent} from './components/filtros/filtros.component'
import {AuthGuard} from './auth.guard'
import {RegisterComponent} from './login/register/register.component'
import {RequestPasswordComponent} from './login/request-password/request-password.component'
import {ResetPasswordComponent} from './login/reset-password/reset-password.component'
import {LipricesComponent} from './liprices/liprices.component'
import {ListatsComponent} from './listats/listats.component'
import {AuthComponent} from './auth/auth.component'
import {
  NbAuthComponent,
  NbLoginComponent,
  NbLogoutComponent,
  NbRegisterComponent,
  NbRequestPasswordComponent,
  NbResetPasswordComponent
} from '@nebular/auth'

import {LoginComponent} from './login/login.component'
import {NgxAuthModule} from './auth/auth.module'
import {PaymentComponent} from './components/payment/payment.component'
import {PaymentChargeComponent} from './components/payment/payment-charge/payment-charge.component'
import {PaymentContainerComponent} from './components/payment/payment-container/payment-container.component'

const routes: Routes = [
  // { path: '', component: HomeComponent, canActivate: [AuthGuard] },
  // { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
  {
    path: 'auth',
    component: AuthComponent,
    children: [
      {
        path: '',
        component: LoginComponent
      },
      {
        path: 'login',
        component: LoginComponent
      },
      {
        path: 'register',
        component: RegisterComponent
      },
      {
        path: 'request-password',
        component: RequestPasswordComponent
      },
      {
        path: 'reset-password',
        component: RequestPasswordComponent
      },
    ]
  },
  {
    path: 'payment',
    component: PaymentContainerComponent,
    children: [
      {
        path: '',
        component: PaymentComponent
      },
      {
        path: 'payment-charge/:plan',
        component: PaymentChargeComponent
      },

    ]
  },
  {
    path: '',
    component: MainComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: HomeComponent
      },
      {
        path: 'home',
        component: HomeComponent,
      },
      {
        path: 'tradedata',
        component: DashboardsComponent
      },
      {
        path: 'liprices',
        component: LipricesComponent
      },
      {
        path: 'listats',
        component: ListatsComponent
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
